export enum ExamEntryDateType {
    LoginWithinGivenTime = 0,
    GivenTimeExpiresExamCompleted = 1
}